<template>
  <side-bar v-show="isSidebarActiveLocal" position-right class="z99 max-w24">
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">VIEW MEMBERS</h2>
      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="scroll-85vh cust-overflow-y5 mx-2">
      <div class="">
        <b-list-group flush class="overflow-x-hidden">
          <b-list-group-item
            action
            v-for="member in members"
            :key="'member-' + member._id"
            class="cursor-pointer py-3"
          >
            <ChannelMember :member="member" :key="member._id" />
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </side-bar>
</template>

<script>
import ChannelMember from "./ChannelMember";
import { mapState } from "vuex";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ChannelMember,
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    ...mapState("channel", {
      members: "selectedChannelMembers",
    }),
  },
};
</script>
<style scoped>
.max-w24 {
  max-width: 24% !important;
}
</style>
